var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibrariesSolid = function SvgLibrariesSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M18.098 15.2 15.505 2.87a1.25 1.25 0 0 0-1.485-.968l-3.657.786a1.256 1.256 0 0 0-.96 1.484l2.592 12.329a1.25 1.25 0 0 0 1.485.97l3.657-.786a1.257 1.257 0 0 0 .96-1.487M10.625 3.917V3.91l3.656-.781.26 1.24-3.656.786zm.781 3.701-.261-1.242 3.657-.786.261 1.243zm5.469 7.845-3.656.781-.26-1.24 3.656-.786.26 1.238zM8.125 2.5h-3.75a1.25 1.25 0 0 0-1.25 1.25v12.5a1.25 1.25 0 0 0 1.25 1.25h3.75a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25m-3.75 1.25h3.75V5h-3.75zm3.75 12.5h-3.75V15h3.75z"
  })));
};
export default SvgLibrariesSolid;